export default "__VITE_ASSET__HkWnTNSM__"